import React from "react";
import classes from "./RefundLaw.css";

const RefundLaw = props => {
    return (
        <div className={props.ShowAnimation ? classes.BackgroundRefund : null}>
            <div className={classes.RefundInFormation}>
                <h2>قوانین استرداد</h2>
                <h3>قابل توجه کلیه آژانس ها و مسافرین محترم</h3>
                <div className={classes.infoConrainer}>
                    <p><b>-</b> لطفا قبل از پر نمودن فرم استرداد وجه <span> ابتدا از کنسل بودن رزرو خود </span>(به غیراز ابطال پرواز و تاخیر بیش از 2 ساعت) <span> در رزرواسیون سپهر </span>محراب سیر کیش اطمینان حاصل نمایید.</p>
                    <p><b>-</b> کاربر گرامی؛ تکمیل فرم (استرداد وجه بلیت) تنها جهت اعلام مشخصات مسافران و شماره کارت بانکی خریداری شده از طرف شما جهت <span> واریز وجه رزرو کنسل شده بوده و به منزله کنسلی رزرو نمی باشد </span> شما باید <b>با ورود به سیستم رزرواسیون (سپهر) و جستجوی رفرنس اقدام به کنسل نمودن رزرو پرواز خود نمایید </b>و پس از انجام عملیات کنسل رزرو، با جستجوی مجدد رفرنس از کنسل بودن آن اطمینان حاصل فرمایید و چنانچه بلیط شما در سیستم رزرواسیون کنسل نشده باشد وجهی استرداد نخواهد شد و شرکت محراب سیر کیش در این مورد هیچ مسولیتی نخواهد داشت.</p>
                    <hr />
                    <p><b>-</b> در هنگام وارد نمودن اطلاعات، <b>حتما شماره کارت بانکی که با آن عملیات خرید انجام شده است </b>را وارد نمایید.</p>
                    <p><b>-</b> جهت تسریع در انجام عملیات پرداخت<b> اولویت با فرم های دارای شماره شبا </b>می باشد. درصورت نداشتن شماره شبا، میتوانید با مراجعه به وب سایت بانک عامل، شماره شبای حساب خود را دریافت نمایید.</p>
                    <hr />
                    <p><b>-</b> کنسل نمودن رزرو توسط شما در سیستم رزرواسیون محراب سیر کیش به معنای پذیرفتن کلیه شرایط <b>(اعم از درصد جریمه ها و ...) </b>توسط شما می باشد.</p>
                    <hr />
                    <p><b>-</b> ثبت درخواست در سامانه استرداد<b> وجه قبل از کنسل نمودن رزرو توسط شما در سیستم رزرواسیون </b>، هیچگونه تعهدی را برای شرکت محراب سیر کیش ایجاد نمی کند.</p>
                    <hr />
                    <p><b>-</b> چنانچه درخواست استرداد وجه شما<b> به علت تاخیر بیش از 2 ساعت</b> می باشد، <span>ارسال اصل بلیط مهرشده توسط ایرلاین </span>به آدرس پستی شرکت محراب سیر کیش الزامی میباشد.</p>
                    <p>کدپستی:73711-نشانی: تهران. خیابان سهروردی شمالی. خیابان خرمشهر. پلاک 182</p>
                    <p>کدپستی:73711-15337</p>
                    <p>کدپستی:73711-تلفن: 88749888-021 داخلی 205</p>
                    <p>کدپستی:73711-پشتیبانی: 7382291-0912</p>
                    <p>کدپستی:73711-فکس 88518726-021</p>
                </div>
                <div className={classes.ClickBox}>
                    <label className={classes.container}>
                        <input type="checkbox" onChange={(event) => props.checkBox(event, "Agree")} />
                        <span className={classes.checkmark}></span>
                        قوانین و مقررات استرداد را با دقت مطالعه کردم.
                </label>
                    <label className={classes.container}>
                        <input onChange={(event) => props.checkBox(event, "NoShow")} type="checkBox" />
                        <span className={classes.checkmark}></span>
                        دیگر این پنجره را نمایش نده
                </label>
                    <button
                        disabled={props.AgreeBTN ? false : true}
                        className={classes.RefundBTN} onClick={props.Agree}> قوانین استرداد را می پذیرم</button>
                    <button
                        disabled={props.AgreeBTN ? true : false}
                        className={classes.NotRefundBTN} onClick={props.CloseRefund}> نمی پذیرم</button>
                </div>
            </div>
        </div>

    )
}

export default RefundLaw